<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.quests', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-1 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                ></th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.difficulty') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.times_required') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.gamification_rewards') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.quantity') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-auto-animate>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(quest, index) in quests.data"
                                :key="quest.id"
                            >
                                <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <BadgePill :color="quest.type_display.color">
                                        {{ quest.type_display.text }}
                                    </BadgePill>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div>
                                        {{ quest.name }}
                                    </div>
                                    <div v-if="quest.is_once_per_day">
                                        <BadgePill color="gray" class="text-xs">
                                            {{ $t('messages.is_once_per_day') }}
                                        </BadgePill>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div v-if="quest.difficulty_display">
                                        <BadgePill :color="quest.difficulty_display.color">
                                            {{ quest.difficulty_display.text }}</BadgePill
                                        >
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ quest.times_required }}
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                                    <div class="flex gap-4">
                                        <div>
                                            <BadgePill
                                                color="green"
                                                class="text-lg"
                                                v-if="quest.experience_amount !== null"
                                            >
                                                {{ quest.experience_amount }}
                                            </BadgePill>
                                        </div>
                                        <div>
                                            <BadgePill
                                                color="yellow"
                                                class="text-lg"
                                                v-if="quest.coins_amount !== null"
                                            >
                                                {{ quest.coins_amount }}
                                            </BadgePill>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ quest.active_student_quests_count }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <ToggleInertiaForm :url="quest.links.toggle" :is-active="quest.is_active" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="quests" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import BadgePill from '@/components/BadgePill.vue';
import ToggleInertiaForm from '@/components/ToggleInertiaForm.vue';

export default {
    components: {
        ToggleInertiaForm,
        BadgePill,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'quests', 'filters', 'gamificationSet'],
};
</script>
